import { Suspense, useEffect, useRef, useState } from "react";

export default function DeferredSection({ children, minHeight = "28rem", placeholderClassName = "", activateAfterScroll = false, testId, id, forceLoad = false, className = "" }) {
  const ref = useRef(null);
  const [isNearViewport, setIsNearViewport] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) {
      setIsNearViewport(true);
      return undefined;
    }
    let isIntersecting = false;
    let observer;
    const activate = () => {
      if (!isIntersecting || (activateAfterScroll && window.scrollY === 0)) return;
      setIsNearViewport(true);
      observer?.disconnect();
      window.removeEventListener("scroll", activate);
    };

    if (!("IntersectionObserver" in window)) {
      isIntersecting = true;
      if (activateAfterScroll && window.scrollY === 0) {
        window.addEventListener("scroll", activate, { passive: true });
        return () => window.removeEventListener("scroll", activate);
      }
      setIsNearViewport(true);
      return undefined;
    }

    observer = new IntersectionObserver(([entry]) => {
      isIntersecting = entry.isIntersecting;
      activate();
    }, { rootMargin: "160px 0px" });
    observer.observe(element);
    if (activateAfterScroll) window.addEventListener("scroll", activate, { passive: true });
    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", activate);
    };
  }, [activateAfterScroll]);

  const isActive = isNearViewport || forceLoad;
  const wrapperClassName = [className, !isActive ? placeholderClassName : ""].filter(Boolean).join(" ") || undefined;

  return (
    <div
      ref={ref}
      id={id}
      data-testid={testId}
      className={wrapperClassName}
      style={isActive || placeholderClassName ? undefined : { minHeight }}
    >
      {isActive && <Suspense fallback={<div data-testid={`${testId}-loading`} className="min-h-[12rem]" />}>{children}</Suspense>}
    </div>
  );
}